<template>
	<div class='story' >
		<!-- <div class="knd-toggle-block">
			<div class="knd-label">{{ data[content.value].description }}</div>
			<Toggle 
				:toggleFn='switchLanguage'
				:value="content.value">

				<template #left>
					{{content.LEFT.label}}
				</template>
				
				<template #right>
					{{content.RIGHT.label}}
				</template>
			</Toggle>
		</div> -->
		<div class="wrap wrap--840">
			<div class="toggle-language">
				<ToggleLanguage 
					:toggleFn='switchLanguage'
					:value="content.value">
				>
					<template #left>
						{{content.LEFT.label}}
					</template>
					
					<template #right>
						{{content.RIGHT.label}}
					</template>

			</ToggleLanguage>
		</div>
		</div>
</div>
</template>

<script>
// import Toggle from './components/toggle';
import ToggleLanguage from './components/toggle/language.vue';

import './scss/index.scss'

export default {
	name: 'App',
	props: {
		content: {
			type: Object
		}
	},	
	data: function() {
		return {
			data2: {
				value: 'LEFT',
				LEFT: {
					description: '',
					label: 'NL',
					url: 'https://pointer.kro-ncrv.nl/deze-vrouwen-werden-seksueel-belaagd-in-de-klassieke-muziekwereld-je-bent-een-prooi '
				},
				RIGHT: {
					description: '',
					label: 'EN',
					url: 'https://pointer.kro-ncrv.nl/these-women-experienced-sexual-harassment-in-classical-music-i-was-prey '
				}
			}
		}
	},
	components: {
		// Toggle,
		ToggleLanguage
	},
	methods: {
		switchLanguage(value) {
			var switchLanguage = this.content[value];
			let delayInMilliseconds = 750;

			setTimeout(() => {
				window.open(switchLanguage.url,"_self");
			}, delayInMilliseconds);
		}
	}
}
</script>


<style lang="scss">
	.knd-app {
			--paragraph-spacing: 4rem;
	}
	.knd-language-toggle {
		margin-left: auto; 
		margin-right: 0;
	}

	.knd-toggle-block {
		width: 100%;
		color: #000;

			.knd-toggle {
				--knd-toggle-links:  #ff5362;
				--knd-toggle-rechts:  #ff5362;
			}
	}
</style>